<template>
    <div>

        <property-toolbar :layout="layout"></property-toolbar>

        <div class="card-body p-0">

            <div class="card-header editor-content d-flex">
                <div>
                    Properties
                </div>
            </div>

            <row-properties v-if="layout.selectedRow" :layout="layout"></row-properties>
            <column-properties v-if="layout.selectedColumn" :layout="layout"></column-properties>

            <button-properties v-if="layout.selectedComponent && !isField && layout.selectedComponent.type === 'Button'"
                               :layout="layout" :view="view"></button-properties>
            <icon-properties v-else-if="layout.selectedComponent && layout.selectedComponent.type === 'Icon'"
                             :layout="layout" :view="view"></icon-properties>
            <component-properties v-else-if="layout.selectedComponent && !isField" :component="layout.selectedComponent" :layout="layout" :view="view"></component-properties>

            <field-properties v-if="layout.selectedComponent && isField" :layout="layout" :view="view"></field-properties>
            <condition-properties v-if="layout.selectedRow && !layout.selectedColumn" :layout="layout" :table="table" :view="view"></condition-properties>

        </div>

    </div>
</template>

<script>
    import ColumnProperties from "./ColumnProperties.vue";
    import RowProperties from "./RowProperties.vue";
    import ComponentProperties from "./ComponentProperties.vue";
    import ConditionProperties from "./ConditionProperties.vue";
    import PropertyToolbar from "./PropertyToolbar.vue";
    import FieldProperties from "./FieldProperties.vue";
    import ButtonProperties from "./ButtonProperties.vue";
    import IconProperties from "./IconProperties.vue";

    export default {
        name: 'PropertyEditor',
        components: {
            IconProperties,
            ButtonProperties,
            FieldProperties,
            PropertyToolbar, ConditionProperties, ComponentProperties, RowProperties, ColumnProperties},
        props: ['layout', 'table', 'view'],
        data() {
            return {
                model: webase.model
            }
        },
        computed: {
            isField() {
                return this.layout.selectedComponent.type === 'Field'
            }
        }
    }
</script>

<style>

</style>
